import { render, staticRenderFns } from "./NotificationPreferencesButton.vue?vue&type=template&id=883250b2&scoped=true"
import script from "./NotificationPreferencesButton.vue?vue&type=script&lang=js"
export * from "./NotificationPreferencesButton.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreferencesButton.vue?vue&type=style&index=0&id=883250b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883250b2",
  null
  
)

export default component.exports